import { Controller } from "@hotwired/stimulus"

// Native share — opens the OS share sheet via the Web Share API. Essential in
// PWA standalone mode, where there's no browser chrome (no URL bar, no browser
// share button) to share the current page from.
//
// Pure progressive enhancement: the FAB is only revealed when navigator.share
// exists (mobile + some desktop). The controller adds `.share-available` to
// <body>, which the CSS uses to show the button and lift the back-to-top FAB
// above it. Where Web Share is absent (most desktops) nothing appears, so the
// austere desktop layout is untouched.
//
// Mounted on <body> in estratos.erb alongside `pwa` and `top`.
export default class extends Controller {
  connect() {
    this.supported =
      typeof navigator !== "undefined" && typeof navigator.share === "function"
    if (!this.supported) return
    document.body.classList.add("share-available")
  }

  disconnect() {
    document.body.classList.remove("share-available")
  }

  async share(event) {
    event?.preventDefault?.()
    if (!this.supported) return

    try {
      await navigator.share({
        title: document.title,
        url: this.canonicalUrl(),
      })
    } catch (error) {
      // AbortError = the user dismissed the share sheet; that's not a failure.
      if (error?.name !== "AbortError") {
        console.error("[share] navigator.share failed:", error)
      }
    }
  }

  // Prefer the canonical link (clean, absolute, no tracking params or hash)
  // emitted by bridgetown-seo-tag; fall back to the live location.
  canonicalUrl() {
    const link = document.querySelector('link[rel="canonical"]')
    return (link && link.href) || window.location.href
  }
}
